import { titleConfig } from "../configs/titleConfig";

const Title = ({ children, className = "", size = "medium" }) => {
  const config = titleConfig[size] || titleConfig.medium;
  return (
    <h2 className={`${config.textSize} ${config.fontWeight} ${className}`}>
      {children}
    </h2>
  );
};

export default Title;
